import { Type } from '@angular/core';

export function isConstructor<T>(value: Function | Type<T>): value is Type<T> {
	return typeof value === 'function'
        && 'prototype' in value
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        && value.prototype.constructor === value;
}
